// extracted by mini-css-extract-plugin
module.exports = {"result":"Result_result__47ZBk","imgWrapper":"Result_imgWrapper__nwChX"};